import { render } from "./ReveivePattyView.vue?vue&type=template&id=ed3efbd6&scoped=true"
import script from "./ReveivePattyView.vue?vue&type=script&lang=js"
export * from "./ReveivePattyView.vue?vue&type=script&lang=js"

import "./ReveivePattyView.vue?vue&type=style&index=0&id=ed3efbd6&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed3efbd6"]])

export default __exports__